<div class="ac-modal">
	<div class="header">
		<h3 class="text-align-center" dcrHTMLKey="COMMON_PERIOD_TITLE">Returns Start Date by Position</h3>
	</div>
	<div class="content larger">
		<div class="common-period-header" dcrHTMLKey="WHAT_IS_THE_COMMON_PERIOD">What is the common period?</div>
		<div class="common-period-summary" dcrHTMLKey="COMMON_PERIOD_DESCRIPTION">
			The common period is the timeframe for which <b>historical performance data is available</b> for your portfolio(s). The Common Period begins at the earliest date for
			which all holdings in your portfolio(s) have returns, i.e, the inception date of the most recently incepted holding. See below for the 'earliest returns date' of all
			holdings.
		</div>
		<div *ngIf="datesAreValid; then validDatesContent; else invalidDatesContent"></div>
		<ng-template #validDatesContent>
			<div *ngIf="isModelPortfolio; then modelPortfolioContent; else normalPortfolioContent"></div>
			<ng-template #modelPortfolioContent>
				<div
					class="common-period-driver"
					dcrHTMLKey="COMMON_PERIOD_MODEL_CONTENT"
					[dcrSubstitutions]="{
						$commonPeriodStartDateString$: commonPeriodStartDate | date : 'MM/dd/yyyy',
						$commonPeriodEndDateString$: commonPeriodEndDate | date : 'MM/dd/yyyy',
						$driverPortfolioName$: driverPortfolioName
					}"
				>
					The Common Period for this analysis is <strong>$commonPeriodStartDateString$</strong> - <strong>$commonPeriodEndDateString$</strong>, driven by
					<strong>$driverPortfolioName$</strong>.
				</div>
			</ng-template>
			<ng-template #normalPortfolioContent>
				<div *ngIf="isCommonPeriodLongerThanTenYears; then commonPeriodLongerThanTenYearsContent; else commonPeriodShorterThanTenYearsContent"></div>
				<ng-template #commonPeriodLongerThanTenYearsContent>
					<div
						class="common-period-driver"
						dcrHTMLKey="COMMON_PERIOD_LONGER_THAN_TEN_YEARS_CONTENT"
						[dcrSubstitutions]="{
							$firstCommonPeriodStartDateString$: commonPeriodStartDate | date : 'MM/dd/yyyy',
							$commonPeriodEndDateString$: commonPeriodEndDate | date : 'MM/dd/yyyy',
							$secondCommonPeriodStartDateString$: commonPeriodStartDate | date : 'MM/dd/yyyy'
						}"
					>
						The Common Period is <strong>$firstCommonPeriodStartDateString$</strong> - <strong>$commonPeriodEndDateString$</strong> because all holdings in the
						portfolio(s) have a start date before <strong>$secondCommonPeriodStartDateString$</strong>.
					</div>
				</ng-template>
				<ng-template #commonPeriodShorterThanTenYearsContent>
					<div
						class="common-period-driver"
						dcrHTMLKey="COMMON_PERIOD_SHORTER_THAN_TEN_YEARS_CONTENT"
						[dcrSubstitutions]="{
							$commonPeriodStartDateString$: commonPeriodStartDate | date : 'MM/dd/yyyy',
							$commonPeriodEndDateString$: commonPeriodEndDate | date : 'MM/dd/yyyy',
							$driverSecurity$: driverSecurity,
							$driverPortfolioName$: driverPortfolioName
						}"
					>
						The Common Period for this analysis is <strong>$commonPeriodStartDateString$</strong> - <strong>$commonPeriodEndDateString$</strong>, driven by
						<strong>$driverSecurity$</strong> in <strong>$driverPortfolioName$</strong>.
					</div>
				</ng-template>
			</ng-template>
		</ng-template>
		<ng-template #invalidDatesContent>
			<div class="common-period-driver"></div>
		</ng-template>

		<bfa-tabs type="underline">
			<ng-container *ngFor="let tableData of tableDatas">
				<ng-template #table>
					<data-table
						[tableData]="tableData"
						[sortable]="true"
						[renderPSView]="true"
						[initialSort]="{ config: sortedColumn, direction: sortDirection }"
						[showPagination]="true"
						[nilSorting]="nilSorting"
					></data-table>
				</ng-template>
				<tab-panel [tab-title]="tableData.headersY[0].formattedValue" [templateRef]="table"></tab-panel>
			</ng-container>
		</bfa-tabs>
	</div>
</div>
